import React, { useState, useContext, useEffect } from "react";
import { useRouter } from "next/router";
import Image from "next/legacy/image";
import dynamic from "next/dynamic";
import { Store } from "@store";
import { useCookies } from "react-cookie";
import { appBaseUrl, domain } from "@base-url";
import classes from "@styles/profile/profile.module.css";
import { getCount } from "@utils/metrics/countMetric";
import defaultcoverpic from "../../public/assets/images/cover.png";
import defaultProfilePic from "@public/assets/images/blank-profile-picture.png";
import shareIcon from "@public/ic_share_custom.png";
import { FEED_TYPES, HTTP_STATUS_CODES } from "@utils/constants";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { updateUser } from "../../queries/user.queries";
import { ModeEditOutlineOutlined as EditIcon, MoreVert as MoreVertIcon } from "@mui/icons-material";
// import DeleteIcon from '@mui/icons-material/Delete';
import { Modal, Tooltip, Tabs, Tab, createTheme, ClickAwayListener, Button } from "@mui/material";
import { NoSsr } from "@mui/material";
import PropTypes from "prop-types";
import { purple } from "@mui/material/colors";
import { ThemeProvider } from "styled-components";

/*--------------------------- queries ------------------------------*/
import { getUser, followUser, unFollowUser, reportUser, blockUser, updateCoverPic, updateProfileDp } from "@queries/user.queries";
import ManagedCommunitiesTab from "./ManagedCommunitiesTab";
import { trackUserAttributes } from "@utils/analytics/event-analytics";
import BlockedUserModal from "@components/modal/BlockedUserModal";
import GuestUserModal from "src/globalModule/components/guestUserModal";
const Sidebar = dynamic(() => import("./UserProfileSidebar"));

/*---------------------- To be loaded at client-side only ---------------------------*/

const ProfileFeeds = dynamic(() => import("@components/profile/ProfileFeeds"), {
  ssr: false
});
const JoinedCommunitiesTab = dynamic(() => import("@components/profile/JoinedCommunitiesTab"), {
  ssr: false
});

// import Transaction from "./Transaction";
const Transaction = dynamic(() => import("./Transaction"), {
  ssr: false
});
const RWebShare = dynamic(() => import("react-web-share").then(mod => mod.RWebShare), {
  ssr: false
});
const UtsavModal = dynamic(() => import("src/globalModule/components/UtsavModal"), {
  ssr: false
});
const Cropper = dynamic(() => import("@components/cropper/Cropper"), {
  ssr: false
});
const EditProfile = dynamic(() => import("@components/profile/EditProfile"), {
  ssr: false
});
const ListModal = dynamic(() => import("@components/modal/ListModal"), {
  ssr: false
});
const UpvoteFollowList = dynamic(() => import("@components/profile/UpvoteFollowList"), {
  ssr: false
});
const FullScreenViewImage = dynamic(() => import("@components/imageView/FullScreenImageView"));
/*--------------------------- components end ------------------------------*/

const theme = createTheme({
  palette: {
    primary: {
      light: purple[600],
      main: purple[800]
    }
  }
});
export default function ProfileContainer({
  data
}) {
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const router = useRouter();
  const {
    uid,
    isFollowerList
  } = router.query;
  const [, setCookie] = useCookies(["refresh"]);
  const UserDetail = data.UserDetail;
  const UserAddress = data.UserAddress;
  const UserMetric = data.UserMetric;
  // const address = getAddress(UserAddress);

  const [value, setValue] = useState(1);
  const [profile_pic, setProfilePic] = useState(loggedInUser.dp ? loggedInUser.dp : defaultProfilePic);
  const [cover_pic, setCoverpic] = useState(defaultcoverpic);
  const [follows, setFollows] = useState(UserMetric.followNo);
  const [follow_check, set_follow_check] = useState();
  const [showFollowersList, setShowFollowersList] = useState(isFollowerList ? true : false);
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showMore, setShowMore] = useState(true);

  //** Full screen image view **/
  const [openFullScreen, setOpenFullScreen] = useState(false);
  const [viewImage, setViewImage] = useState("");

  ///=== For Cropper =====////
  const [upImgProfile, setUpImgProfile] = useState();
  const [upImgCover, setUpImgCover] = useState();
  const [openEditModalProfile, setOpenEditModalProfile] = useState(false);
  const [openEditModalCover, setOpenEditModalCover] = useState(false);
  const [filename, setFilename] = useState("");
  const [profilePicUpload, setProfilePicUpload] = useState(null);

  // --UtsavModal config
  const [openModal, setOpenModal] = useState(false);
  const [openBlockModal, setOpenBlockModal] = useState(false);
  const [openReportModal, setOpenReportModal] = useState(false);
  const [openReportSuccessModal, setOpenReportSuccessModal] = useState(false);
  const [modalHeading, setModalHeading] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [openBlockedUserModal, setOpenBlockedUserModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const toggleBlockedServiceModal = () => {
    setOpenBlockedUserModal(!openBlockedUserModal);
  };
  //const [openUnauthorizedModal, setOpenUnauthorizedModal] = useState(false);
  // const handleOpenUnauthorizedModal = () => {
  //   setOpenUnauthorizedModal(!openUnauthorizedModal);
  // };
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const profileLink = `${appBaseUrl}/${router.locale}/profile/${data.uid}`;

  // let share_url
  // if(loggedInUser.referralID){
  //   share_url = `\nProfile Link: ${profileLink} \n\nDownload Utsav App👇 \nhttps://utsavapp.in/download?referrer=${loggedInUser.referralID}`
  // }else{
  //   share_url = `\nProfile Link: ${profileLink} \n\nDownload Utsav App👇 \nhttps://utsavapp.in/download`
  // }

  // make value to be 4 if !router?.query?.registrationID is true

  useEffect(() => {
    if (router?.query?.registrationID) {
      setValue(4);
    }
    //setValue(4);
  }, [router?.query?.registrationID]);
  useEffect(() => {
    const query = router.query;
    if (typeof window !== "undefined") {
      if (query?.tab === "3" && window.innerWidth > 992) {
        setValue(3);
      }
    }
  }, [router.query]);
  useEffect(() => {
    setProfilePic(data.dp);
    if (data.coverPic) {
      setCoverpic(data.coverPic);
    } else {
      setCoverpic(defaultcoverpic);
    }
  }, [data]);
  useEffect(() => {
    let id = router?.query?.params[0];
    let accessToken = loggedInUser?.accessToken;
    async function getuser() {
      let {
        data,
        err
      } = await getUser({
        profileUid: id,
        accessToken: accessToken
      });
      if (data) {
        set_follow_check(data.UserMetric.isFollowing);
      }
    }
    getuser();
  }, [follow_check]);
  const toggleModal = () => {
    setOpenModal(cur => !cur);
  };
  const toggleReportModal = () => {
    setOpenReportModal(cur => !cur);
  };
  const toggleReportSuccessModal = () => {
    setOpenReportSuccessModal(cur => !cur);
  };
  const toggleBlockModal = () => {
    setOpenBlockModal(cur => !cur);
  };
  const startCrop = (file, type) => {
    if (file) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        if (type === "profile") setUpImgProfile(reader.result);else setUpImgCover(reader.result);
      });
      reader.readAsDataURL(file);
    }
  };
  function viewFullImage(imgsrc, type) {
    let flag = true;
    if (type === "cover" && (!cover_pic || cover_pic === defaultcoverpic)) flag = false;
    if (type === "profile" && !profile_pic) flag = false;
    if (flag) {
      setViewImage(imgsrc);
      setOpenFullScreen(true);
    }
  }

  ////======= FULLSCREEN IMAGE VIEW COMPONENT END ======///
  ////////======= PROFILE AND COVER PICTURE UPDATE START ======///////
  const handleImageUpload = async image => {
    if (profilePicUpload) updateprofilepicdata(image);else if (!profilePicUpload) updatecoverpicdata(image);
    setProfilePicUpload(null);
  };
  const handleImageChange = (e, type) => {
    if (e.target.files && e.target.files.length > 0) {
      const fname = e.target.files[0].name;
      if (fname.endsWith(".jpg") || fname.endsWith(".jpeg") || fname.endsWith(".png")) {
        const imageFile = e.target.files[0];
        startCrop(imageFile, type);
        if (type === "profile") setOpenEditModalProfile(true);else setOpenEditModalCover(true);
        setFilename(fname);
      } else {
        setModalHeading("Invalid Format.");
        setModalMessage("This format is not supported.");
        toggleModal();
      }
    }
  };
  const uploadProfilePicture = e => {
    if (e.target.files[0]) {
      setProfilePicUpload(true);
      handleImageChange(e, "profile");
    }
  };
  const uploadCoverPicture = e => {
    if (e.target.files[0]) {
      setProfilePicUpload(false);
      handleImageChange(e, "cover");
    }
  };
  function changeProfilePicture() {
    const a = document.getElementById("profile-picture-file-input");
    a.value = "";
    a.click();
  }
  function changeCoverPicture() {
    const b = document.getElementById("cover-picture-file-input");
    b.value = "";
    b.click();
  }
  const removeProfilePicture = e => {
    removeProfilePicdata();
  };
  async function removeProfilePicdata() {
    const result = await updateUser({
      data: {
        uid: loggedInUser.uid,
        communityIds: loggedInUser.communityIds,
        isSelected: loggedInUser?.isSelected,
        userReferal: loggedInUser?.userReferal,
        name: loggedInUser.name,
        dp: "",
        UserMetric,
        UserDetail,
        UserAddress
      },
      accessToken: loggedInUser.accessToken
    });
    if (result && !result.success && result.code === HTTP_STATUS_CODES.BLOCKED) {
      setErrorMsg(result.message);
      toggleBlockedServiceModal();
      return () => {};
    }
    if (result?.success && result?.data) {
      setProfilePic(defaultProfilePic);
      loggedInUser.dp = defaultProfilePic;
      try {
        trackUserAttributes(loggedInUser);
      } catch (error) {}
      setCookie("refresh", "true", {
        secure: true,
        domain: domain
      });
    } else {
      alert("Something went wrong!");
    }
  }
  async function updateprofilepicdata(img) {
    const result = await updateProfileDp({
      uid: loggedInUser.uid,
      image: img,
      isSharing: false,
      caption: "",
      accessToken: loggedInUser.accessToken
    });
    if (result && !result.success && result.code === HTTP_STATUS_CODES.BLOCKED) {
      setErrorMsg(result.message);
      toggleBlockedServiceModal();
      return () => {};
    }
    if (result?.success && result?.response?.length > 0) {
      setProfilePic(result?.response[0]);
      loggedInUser.dp = result?.response[0];
      data.dp = result?.response[0];
      data.dp_sm = result?.response[0];
      trackUserAttributes(loggedInUser);
      setCookie("refresh", "true", {
        secure: true,
        domain: domain
      });
    } else {
      alert("Something went wrong!");
    }
  }
  async function updatecoverpicdata(link) {
    const result = await updateCoverPic({
      uid: loggedInUser.uid,
      image: link,
      isSharing: false,
      caption: "",
      accessToken: loggedInUser.accessToken
    });
    if (result && !result.success && result.code === HTTP_STATUS_CODES.BLOCKED) {
      setErrorMsg(result.message);
      toggleBlockedServiceModal();
      return () => {};
    }
    if (result?.success && result?.response?.length > 0) {
      setCoverpic(result?.response[0]);
      loggedInUser.coverPic = result.response[0];
      data.coverPic = result.response[0];
      trackUserAttributes(loggedInUser);
    } else {
      alert("Something went wrong!");
    }
  }
  async function removeCoverPicdata() {
    const result = await updateUser({
      data: {
        uid: loggedInUser.uid,
        communityIds: loggedInUser.communityIds,
        isSelected: loggedInUser?.isSelected,
        userReferal: loggedInUser?.userReferal,
        name: loggedInUser.name,
        dp: loggedInUser.dp,
        coverPic: "",
        UserMetric,
        UserDetail,
        UserAddress
      },
      accessToken: loggedInUser.accessToken
    });
    if (result && !result.success && result.code === HTTP_STATUS_CODES.BLOCKED) {
      setErrorMsg(result.message);
      toggleBlockedServiceModal();
      return () => {};
    }
    if (result?.success && result?.response) {
      setCoverpic(defaultcoverpic);
      loggedInUser.coverPic = null;
      data.coverPic = null;
      try {
        trackUserAttributes(loggedInUser);
      } catch (error) {}
      setCookie("refresh", "true", {
        secure: true,
        domain: domain
      });
    } else {
      alert("Something went wrong!");
    }
  }
  function removeCoverPicture() {
    removeCoverPicdata();
  }

  ////////======= PROFILE AND COVER PICTURE UPDATE START ======///////

  //////======= TAB CHANGE FUNCTION ======/////
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  ////////======= UPDATE PROFILE DATA START ======///////

  function openEditProfile() {
    setShowEditProfile(true);
  }
  const EditProfileModal = () => {
    function closeModal() {
      setShowEditProfile(false);
    }
    return <>
        <NoSsr data-sentry-element="NoSsr" data-sentry-source-file="UserProfile.jsx">
          <Modal open={showEditProfile} data-sentry-element="Modal" data-sentry-source-file="UserProfile.jsx">
            <div className={`${classes.editProfile_overlay}`}>
              <div className={`${classes.editProfile}`}>
                <EditProfile data={data} close={closeModal} data-sentry-element="EditProfile" data-sentry-source-file="UserProfile.jsx" />
              </div>
            </div>
          </Modal>
        </NoSsr>
      </>;
  };

  ////////======= UPDATE PROFILE DATA END ======///////

  const followHandle = async AddorRemove => {
    let res;
    if (AddorRemove === "add") {
      res = await followUser({
        uid: data.uid,
        accessToken: loggedInUser.accessToken
      });
    } else {
      res = await unFollowUser({
        uid: data.uid,
        accessToken: loggedInUser.accessToken
      });
    }
    if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
      setErrorMsg(res.message);
      toggleBlockedServiceModal();
      return () => {};
    }
  };
  const followClickHandler = () => {
    if (loggedInUser.accessToken == null) {
      //setOpenUnauthorizedModal(true);
      setLoginModalOpen(true);
      return () => {};
    }
    if (follow_check) {
      followHandle("remove");
      setFollows(follow => follow - 1);
    } else {
      followHandle("add");
      setFollows(follow => follow + 1);
    }
    set_follow_check(cur => !cur);
  };
  function openFollowListModal() {
    if (follows > 0) setShowFollowersList(true);
  }
  function showmore() {
    setShowMore(!showMore);
  }
  const coverPicLoadErrorHandler = e => {
    e.target.src = defaultcoverpic;
  };

  // function viewLocation() {
  //   const text = encodeURIComponent(address);
  //   window.open(`https://www.google.com/maps/search/${text}`);
  // }

  const handleReport = async () => {
    const res = await reportUser({
      uid: data.uid,
      accessToken: loggedInUser.accessToken
    });
    if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
      setErrorMsg(res.message);
      toggleBlockedServiceModal();
      return () => {};
    }
    // toggleReportModal();
    if (res.success) toggleReportSuccessModal();else alert("Something went wrong!");
  };
  const handleBlock = async () => {
    const res = await blockUser({
      uid: data.uid,
      accessToken: loggedInUser.accessToken
    });
    if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
      setErrorMsg(res.message);
      toggleBlockedServiceModal();
      return () => {};
    }
    if (res.success) {
      router.push("/home");
    }
  };
  function MoreOptions() {
    return <div className={classes.profileMoreOptions} data-sentry-component="MoreOptions" data-sentry-source-file="UserProfile.jsx">
        <p onClick={toggleReportModal}>Report</p>
        <p onClick={toggleBlockModal}>Block</p>
      </div>;
  }
  function handleClickAway() {
    setShowMoreOptions(false);
  }
  return <>
      <div className={`${classes.profile}`}>
        <div className={classes.profile_display}>
          <div className={classes.profile_display_inner_left}>
            <div className={`${classes.profile_display_cover}`}>
              <div>
                {loggedInUser.uid !== data.uid && <NoSsr>
                    <ClickAwayListener onClickAway={handleClickAway}>
                      <button className={`btn-sm ${classes.btn} ${classes.profile_display_cover_more}`} onClick={() => setShowMoreOptions(cur => !cur)} color="success">
                        <MoreVertIcon />
                      </button>
                    </ClickAwayListener>
                  </NoSsr>}

                {showMoreOptions && <>
                    <NoSsr>
                      <MoreOptions />
                    </NoSsr>
                  </>}
              </div>
              <div className={`${classes.profile_display_cover_img}`} onClick={() => viewFullImage(cover_pic, "cover")}>
                <Image src={cover_pic} alt="cover" id="coverPicture" layout="fill" priority onError={coverPicLoadErrorHandler} data-sentry-element="Image" data-sentry-source-file="UserProfile.jsx" />
              </div>
              <input type="file" accept="image/*" id="cover-picture-file-input" hidden="hidden" onChange={uploadCoverPicture} />

              {loggedInUser.uid === data.uid && cover_pic !== defaultcoverpic && <NoSsr>
                    <Tooltip title="remove Cover picture" placement="bottom">
                      <button className={`${classes.profile_display_cover_delete} ${classes.btn} btn-sm`} onClick={removeCoverPicture}>
                        <CloseIcon fontSize="small" />
                      </button>
                    </Tooltip>
                  </NoSsr>}

              {loggedInUser.uid === data.uid && <NoSsr>
                  <Tooltip title="Edit Cover picture" placement="bottom">
                    <button className={`${classes.profile_display_cover_edit} ${classes.btn} btn-sm`} onClick={changeCoverPicture}>
                      <EditIcon fontSize="small" />
                    </button>
                  </Tooltip>
                </NoSsr>}
            </div>

            <div className={`${classes.profile_display_about}`}>
              <div className={`${classes.profile_display_row}`}>
                <div className={`${classes.profile_display_about_com}`}>
                  <>
                    <RWebShare data={{
                    text: `${data.name}'s profile on Utsav - `,
                    url: profileLink,
                    title: "Utsav"
                  }} sites={["whatsapp", "mail", "linkedin", "telegram"]} onClick={() => {}} className={`${classes.profile_display_about_share}`} data-sentry-element="RWebShare" data-sentry-source-file="UserProfile.jsx">
                      <button className={`${classes.btn} ${classes.profile_display_about_share}`}>
                        <Image src={shareIcon} alt="Share Icon" className={classes.shareIcon} data-sentry-element="Image" data-sentry-source-file="UserProfile.jsx" />
                      </button>
                    </RWebShare>
                  </>

                  {loggedInUser.uid === data.uid ? <NoSsr>
                      <Tooltip title="Edit Profile" placement="right">
                        <button className={`${classes.profile_display_about_profile_edit}`} onClick={openEditProfile}>
                          Edit Profile
                        </button>
                      </Tooltip>
                    </NoSsr> : <>
                      {follow_check ? <button className={`${classes.btn} ${classes.btn_following_profile}`} onClick={followClickHandler}>
                          Following
                        </button> : <button className={`${classes.btn} ${classes.btn_follow_profile}`} onClick={followClickHandler}>
                          Follow
                        </button>}
                    </>}
                </div>

                <div>
                  <div className={`${classes.profile_display_about_imgC}`}>
                    <div className={`${classes.profile_display_about_img}  ${classes.profile_dp_com}`}>
                      {/* <Avatar
                          src={profile_pic ?? defaultProfilePic}
                          alt={data.name}
                          className={classes.userAvatar}
                          onClick={() => viewFullImage(profile_pic, "profile")}
                        > */}
                      <Image src={profile_pic || defaultProfilePic} alt={`${data.name} profile pic`} width="160" height="160" objectFit="cover" className={classes.userAvatar} data-sentry-element="Image" data-sentry-source-file="UserProfile.jsx" />
                      {/* </Avatar> */}
                    </div>

                    <input type="file" accept="image/*" id="profile-picture-file-input" hidden="hidden" onChange={uploadProfilePicture} />
                    {loggedInUser.uid === data.uid && <NoSsr style={{
                    position: "relative",
                    border: "1px solid red"
                  }}>
                        <button className={`${classes.btn} ${classes.profile_display_about_img_edit}`} onClick={handleClickOpen}>
                          <EditIcon />
                        </button>

                        <div>
                          <Dialog open={open} onClose={handleClose}>
                            <DialogTitle id="alert-dialog-title" sx={{
                          fontFamily: '"candara",sans-serif',
                          fontWeight: "bold"
                        }}>
                              {"What Do you wanted to do?"}
                            </DialogTitle>
                            <DialogActions sx={{
                          display: "flex",
                          justifyContent: "space-around",
                          fontFamily: '"candara",sans-serif',
                          fontWeight: "bold"
                        }}>
                              <Button onClick={() => {
                            handleClose();
                            changeProfilePicture();
                          }} style={{
                            color: "green",
                            fontFamily: '"candara",sans-serif',
                            fontWeight: "bold",
                            borderColor: "gray",
                            padding: "0px 5px"
                          }} variant="outlined">
                                Change Pic
                              </Button>
                              <Button onClick={() => {
                            removeProfilePicture();
                            handleClose();
                          }} style={{
                            color: "red",
                            fontFamily: '"candara",sans-serif',
                            fontWeight: "bold",
                            borderColor: "gray",
                            padding: "0px 5px"
                          }} variant="outlined">
                                Remove Pic
                              </Button>
                            </DialogActions>
                          </Dialog>
                        </div>
                      </NoSsr>}
                  </div>
                </div>
                <div className={classes.profile_display_container}>
                  <div className={`${classes.profile_display_middle}`}>
                    <div className={`${classes.profile_display_about_user_individual}`}>
                      <div className={`${classes.profile_display_about_user_name}`}>
                        {data.name}
                      </div>
                      <div className={classes.count_section_left}>
                        <div className={`${classes.profile_display_about_user_span}`}>
                          <b>{getCount(UserMetric.visitNo)}</b>
                          <span className={`${classes.follows_upvotes_font}`}>
                            Visits
                          </span>
                        </div>
                        <div className={`${classes.profile_display_about_user_span}`} onClick={openFollowListModal}>
                          <b>{getCount(follows)}</b>
                          <span className={`${classes.follows_upvotes_font}`}>
                            Followers
                          </span>
                        </div>
                        <div className={`${classes.profile_display_about_user_span}`}>
                          <b>{getCount(UserMetric.likeNo)}</b>
                          <span className={`${classes.follows_upvotes_font}`}>
                            Likes
                          </span>
                        </div>
                      </div>

                      {UserDetail?.about && <div className={`${classes.profile_display_user_about} ${classes.userProfileAbout}`}>
                          {UserDetail.about?.length <= 120 && UserDetail.about}
                          {UserDetail.about?.length > 120 ? showMore ? UserDetail.about.slice(0, 120) : UserDetail.about.slice(0, UserDetail.about.length + 1) : null}
                          {UserDetail.about?.length > 120 ? !showMore ? <span className={`${classes.less_more}`} onClick={showmore}>
                                show less
                              </span> : <span className={`${classes.less_more}`} onClick={showmore}>
                                ...show more
                              </span> : null}
                        </div>}
                      {/* {address ? (
                        <div
                          className={`${classes.profile_display_about_user_all} ${classes.userProfileAbout}`}
                        >
                          {address}{" "}
                          <span
                            className={classes.addressSideIcon}
                            onClick={viewLocation}
                          >
                            <NoSsr>
                              <OpenInNewIcon fontSize="small" />
                            </NoSsr>
                          </span>
                        </div>
                       ) : null} */}
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${classes.profile_tabs}`}>
                <div className={`${classes.tabs_switch_div}`}>
                  <ThemeProvider theme={theme} data-sentry-element="ThemeProvider" data-sentry-source-file="UserProfile.jsx">
                    <Tabs variant="scrollable" scrollButtons allowScrollButtonsMobile value={value} onChange={handleChange} TabIndicatorProps={{
                    style: {
                      background: "linear-gradient(90deg, #FF9800 0%, #FF5757 100%)",
                      color: "black",
                      fontSize: "20px"
                    }
                  }} data-sentry-element="Tabs" data-sentry-source-file="UserProfile.jsx">
                      <Tab label={"Posts"} value={1} className={`${classes.tabs} ${value === 1 ? classes.active_tab : ""}`} data-sentry-element="Tab" data-sentry-source-file="UserProfile.jsx" />
                      <Tab label={"Utsav TV"} value={2} className={`${classes.tabs} ${value === 2 ? classes.active_tab : ""}`} data-sentry-element="Tab" data-sentry-source-file="UserProfile.jsx" />
                      <Tab label={"Communities"} value={3} className={`${classes.tabs} ${classes.user_joined_communities_tab} ${value === 3 ? classes.active_tab : ""}`} data-sentry-element="Tab" data-sentry-source-file="UserProfile.jsx" />
                      {loggedInUser.uid === data.uid ? <Tab label={"Puja Bookings"} value={4} className={`${classes.tabs} ${value === 4 ? classes.active_tab : ""}`} /> : ""}
                      <Tab label={"Managed Communities"} value={5} className={`${classes.tabs} ${value === 5 ? classes.active_tab : ""}`} data-sentry-element="Tab" data-sentry-source-file="UserProfile.jsx" />
                    </Tabs>
                  </ThemeProvider>
                </div>
              </div>
            </div>

            <TabPanel value={value} index={1} data-sentry-element="TabPanel" data-sentry-source-file="UserProfile.jsx">
              <ProfileFeeds profileUid={data.uid} postType={FEED_TYPES.IMAGE} data-sentry-element="ProfileFeeds" data-sentry-source-file="UserProfile.jsx" />
            </TabPanel>
            <TabPanel value={value} index={2} data-sentry-element="TabPanel" data-sentry-source-file="UserProfile.jsx">
              <ProfileFeeds profileUid={data.uid} postType={FEED_TYPES.VIDEO} data-sentry-element="ProfileFeeds" data-sentry-source-file="UserProfile.jsx" />
            </TabPanel>
            <TabPanel value={value} index={3} data-sentry-element="TabPanel" data-sentry-source-file="UserProfile.jsx">
              <JoinedCommunitiesTab uid={data.uid} data-sentry-element="JoinedCommunitiesTab" data-sentry-source-file="UserProfile.jsx" />
            </TabPanel>
            <TabPanel value={value} index={4} data-sentry-element="TabPanel" data-sentry-source-file="UserProfile.jsx">
              <Transaction userDetail={data?.UserDetail} data-sentry-element="Transaction" data-sentry-source-file="UserProfile.jsx" />
            </TabPanel>
            <TabPanel value={value} index={5} data-sentry-element="TabPanel" data-sentry-source-file="UserProfile.jsx">
              <ManagedCommunitiesTab data-sentry-element="ManagedCommunitiesTab" data-sentry-source-file="UserProfile.jsx" />
            </TabPanel>
          </div>

          <Sidebar uid={data.uid} data={data} openEditProfile={openEditProfile} data-sentry-element="Sidebar" data-sentry-source-file="UserProfile.jsx" />
        </div>
      </div>

      <FullScreenViewImage openModal={openFullScreen} closeModal={() => setOpenFullScreen(false)} imageSrc={viewImage} data-sentry-element="FullScreenViewImage" data-sentry-source-file="UserProfile.jsx" />

      <Cropper aspectRatio={1} image={upImgProfile} filename={filename} open={openEditModalProfile} setOpen={setOpenEditModalProfile} setImages={handleImageUpload} data-sentry-element="Cropper" data-sentry-source-file="UserProfile.jsx" />

      <Cropper aspectRatio={3} image={upImgCover} filename={filename} open={openEditModalCover} setOpen={setOpenEditModalCover} setImages={handleImageUpload} data-sentry-element="Cropper" data-sentry-source-file="UserProfile.jsx" />

      <EditProfileModal data-sentry-element="EditProfileModal" data-sentry-source-file="UserProfile.jsx" />

      <ListModal show={showFollowersList} heading="Followers" setShowList={setShowFollowersList} data-sentry-element="ListModal" data-sentry-source-file="UserProfile.jsx">
        <UpvoteFollowList for="follow" profileUid={data.uid} data-sentry-element="UpvoteFollowList" data-sentry-source-file="UserProfile.jsx" />
      </ListModal>

      {isLoginModalOpen && <GuestUserModal isLoginModalOpen={isLoginModalOpen} setLoginModalOpen={setLoginModalOpen} />}

      {openModal && <UtsavModal open={openModal} heading={modalHeading} message={modalMessage} acceptMsg="Okay" onAccept={toggleModal} />}

      {openReportModal && <UtsavModal open={openReportModal} toggleModal={toggleReportModal} heading={"Confirm Report"} message={"Are you sure want to Report this user ?"} acceptMsg={"Yes , Report"} onAccept={handleReport} rejectMsg="Cancel" positive={false} />}

      {openReportSuccessModal && <UtsavModal open={openReportSuccessModal} toggleModal={toggleReportSuccessModal} heading="User Reported." message="The user has beed reported." acceptMsg="Okay" />}

      {openBlockModal && <UtsavModal open={openBlockModal} toggleModal={toggleBlockModal} heading={"Confirm Block"} message={"Are you sure want to Block this user ?"} acceptMsg={"Yes , Block"} onAccept={handleBlock} rejectMsg={"Cancel"} positive={false} />}

      {openBlockedUserModal && <BlockedUserModal open={openBlockedUserModal} toggleModal={toggleBlockedServiceModal} message={errorMsg} acceptMsg="Contact Utsav" rejectMsg="Cancel" positive={true} />}
    </>;
}
function TabPanel(props) {
  const {
    value,
    index,
    ...other
  } = props;
  return <div role="tabpanel" hidden={value !== index} {...other} data-sentry-component="TabPanel" data-sentry-source-file="UserProfile.jsx"></div>;
}
TabPanel.propTypes = {
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

// function getAddress(UserAddress) {
//   return `${UserAddress.address ? UserAddress.address + ", " : ""}${
//     UserAddress.city ? UserAddress.city + ", " : ""
//   }${UserAddress.state ? UserAddress.state : ""}`;
// }